module.exports = __webpack_public_path__ + "static/media/completed.b09001e6.svg";